module.exports = __webpack_public_path__ + "static/media/edit_small_filled_gray800.6ef4000e.svg";